import { render } from "./CategorySubcategoryTable.vue?vue&type=template&id=63eeeb3a&scoped=true"
import script from "./CategorySubcategoryTable.vue?vue&type=script&lang=js"
export * from "./CategorySubcategoryTable.vue?vue&type=script&lang=js"

import "./CategorySubcategoryTable.vue?vue&type=style&index=0&id=63eeeb3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eeeb3a"]])

export default __exports__